import GameItem from "../../../common/components/game-item/GameItem";
import { GAMES } from "../../../common/utils/games";
import Section from "./section/Section";
import { Link } from "react-router-dom";
import T from "../../../common/i18n/Text";
import Button from "../../../common/components/Button";
import React from "react";

export const TopGamesSection = () => {
  return (
    <Section titlePath="home.games.title">
      <ul>
        {GAMES.slice(0, 3).map((game) => (
          <li
            key={game.name}
            className="mb-[36px] md:mb-[46px] last:mb-0 md:last:mb-0 hover:shadow-2xl">
            <GameItem game={game} />
          </li>
        ))}
      </ul>
      <Link className="block pt-[15px] mx-auto w-fit" to="/games">
          <Button className="whitespace-nowrap !w-fit" type="cta" name="hero-play"><T path="home.games.see-all" /></Button>
      </Link>
    </Section>
  );
};
